import { render, staticRenderFns } from "./NewSynonym.vue?vue&type=template&id=856afbe0"
import script from "./NewSynonym.vue?vue&type=script&lang=js"
export * from "./NewSynonym.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports